import { ReactNode, createContext, useState } from "react"

interface SidebarContextType {
    showSideMenu: boolean;
    enableSideMenu: (content: any) => void;
    disableSideMenu: () => void;
    menuContent: ReactNode | null;
    setShowSideMenu: React.Dispatch<React.SetStateAction<boolean>>
}

export const SideMenuContext = createContext<SidebarContextType | undefined>(undefined);
export const SideMenuProvider = ({ children }) => {
    const [showSideMenu, setShowSideMenu] = useState(true);
    const [menuContent, setMenuContent] = useState(undefined);

    const enableSideMenu = (content = undefined) => {
        setShowSideMenu(true);
        setMenuContent(content);
    }

    const disableSideMenu = () => {
        setShowSideMenu(false);
        setMenuContent(undefined);
    }

    return (
        <SideMenuContext.Provider value={{
            showSideMenu,
            menuContent,
            enableSideMenu,
            disableSideMenu,
            setShowSideMenu,
            // topBannerContent,
            // setTopBannerContent,
        }}>
            {children}
        </SideMenuContext.Provider>

    )

}